<template>
  <main class="main">
    <portal to="headerTitle">
      {{ $t('admin.pageHotelmeisterInvoices.title') }}
    </portal>
    <template v-if="!isNil(invoices)">
      <card :title="$t('admin.pageHotelmeisterInvoices.card.general')" cols="12" rows="1">
        <hm-card-inner :full-size="true">
          <hm-table :hover="true"
                    min-width="400px"
                    columns="6"
                    grid-template-columns="2fr 1fr 4fr 1fr 1fr 1fr">
            <template slot="table-head">
              <div class="hm-table__th">{{ $t('admin.pageHotelmeisterInvoices.invoice.invoiceNumber') }}</div>
              <div class="hm-table__th">{{ $t('admin.pageHotelmeisterInvoices.invoice.invoiceDate') }}</div>
              <div class="hm-table__th">{{ $t('admin.pageHotelmeisterInvoices.invoice.invoiceTextHead') }}</div>
              <div class="hm-table__th text-right">{{ $t('admin.pageHotelmeisterInvoices.invoice.sumNet') }}</div>
              <div class="hm-table__th text-right">{{ $t('admin.pageHotelmeisterInvoices.invoice.sumGross') }}</div>
              <div class="hm-table__th">&nbsp;</div>
            </template>
            <template v-for="invoice in invoices">
              <template v-if="invoice.status === '1000' || invoice.status === '200'"> <!-- 1000 = paid, 200 = created but not paid -->
                <div :key="`${invoice.id}-id`" class="hm-table__td" @click="downloadInvoice(invoice.id)">{{ invoice.invoiceNumber }}</div>
                <div :key="`${invoice.id}-invoiceDate`" class="hm-table__td" @click="downloadInvoice(invoice.id)">{{ invoice.invoiceDate | toDate }}</div>
                <div :key="`${invoice.id}-headText`" class="hm-table__td" @click="downloadInvoice(invoice.id)">{{ striptags(invoice.headText) }}</div>
                <div :key="`${invoice.id}-sumNet`" :class="[{ 'color--red': parseFloat(invoice.sumNet) < 0 }]" class="hm-table__td text-right" @click="downloadInvoice(invoice.id)">{{ parseFloat(invoice.sumNet) | toCurrency }} EUR</div>
                <div :key="`${invoice.id}-sumGross`" :class="[{ 'color--red': parseFloat(invoice.sumNet) < 0 }]" class="hm-table__td text-right" @click="downloadInvoice(invoice.id)">{{ parseFloat(invoice.sumGross) | toCurrency }} EUR</div>
                <div :key="`${invoice.id}-icons`" class="hm-table__td hm-table__td--icon" @click="downloadInvoice(invoice.id)">
                  <span class="quick-action-button" @click="downloadInvoice(invoice.id)">
                    <icon icon="pdf" />
                  </span>
                </div>
              </template>
            </template>
          </hm-table>
        </hm-card-inner>
      </card>
    </template>
  </main>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import { cloneDeep, groupBy, isEmpty, isNil, sortBy } from 'lodash';
import HmInputNumber from '../../lib/inputs/HmInputNumber';
import HmInputToggle from '../../lib/inputs/HmInputToggle';
import HmCardInner from '../../lib/layout/HmCardInner';
import HmInputMultilang from '../../lib/inputs/HmInputMultilang';
import FilterMixin from '../../../mixins/FilterMixin';
import striptags from 'striptags';

export default {
  name: 'PageHotelSettings',
  components: { HmInputMultilang, HmCardInner, HmInputToggle, HmInputNumber },
  mixins: [HotelmeisterMixin, FilterMixin],

  data() {
    return {
      invoices: null,
    };
  },

  computed: {
  },

  watch: {
  },

  created: function () {
    this.loadData();
  },

  updated() {
  },

  beforeDestroy() {
  },

  methods: {
    striptags,
    loadData() {
      this.axios.get(this.serviceUrls.hotelmeisterInvoice.list(this))
        .then((response) => {
          this.invoices = response.data.data.objects;
        });
    },
    downloadInvoice(invoiceId) {
      this.$serviceBus.$emit('printPDF', `${window.getBaseApiAddresses()}${this.serviceUrls.hotelmeisterInvoice.download(this, invoiceId)}?token=${window.getToken(this.$root.hotel)}`);
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
  @import '~styles/import';

</style>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/pages/admin/PageHotelmeisterInvoices.vue